import { render } from "./dataBodyPart.vue?vue&type=template&id=254de6a6"
import script from "./dataBodyPart.vue?vue&type=script&lang=js"
export * from "./dataBodyPart.vue?vue&type=script&lang=js"

import "./dataBodyPart.vue?vue&type=style&index=0&id=254de6a6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__